import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import colors from '../../styles/colors';

export const Container = styled.header`
  background: #fff;
  padding: 0 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 10;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

export const Content = styled.div`
  height: 64px;
  margin: 0 auto;
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }

  img {
    margin-right: 20px;
    padding-right: 20px;
    border-right: 1px solid #eee;
    height: 32px;
    flex-shrink: 0;

    @media (max-width: 768px) {
      border-right: none;
    }
  }

  nav {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0; /* Essencial para o overflow-x funcionar em flexbox */
    overflow-x: auto;
    padding: 15px 0; /* Extra space at both top and bottom */
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    a {
      font-weight: bold;
      color: #999;
      margin-right: 30px;
      text-transform: uppercase;
      font-size: 14px;
      transition: color 0.2s;
      white-space: nowrap;
      flex-shrink: 0;
      line-height: 2.2; /* Even more line-height */
      display: inline-block;
      vertical-align: middle;

      &:hover {
        color: #666;
      }

      &.active {
        color: ${colors.primary};
      }
    }
  }

  aside {
    display: flex;
    align-items: center;
    margin-left: 10px;
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    height: auto;
    min-height: 80px;
    padding: 15px 10px;

    img {
      margin-right: 0;
      padding-right: 0;
      margin-bottom: 10px;
      height: 24px;
    }

    nav {
      width: 100%;
      justify-content: center;

      a {
        margin-right: 15px;
        font-size: 12px;
        padding-top: 5px; /* Space for accents */
      }
    }
  }
`;

export const NavigationLink = styled(NavLink)`
  &.active {
    color: ${colors.primary} !important;
  }
`;
